import React from 'react';

/**
 * Teacher select that says WHY each option is out — the rebuild card's note 2,
 * and the mockup's best interaction.
 *
 * TWO RULES BAKED IN, BOTH FROM THE CARD:
 *
 * 1. A disabled <option> renders low-contrast in every browser, so a
 *    load-bearing reason may not survive the trip to the user's eye. Nothing
 *    here is disabled — every teacher stays selectable, and the reason rides
 *    along as text. The conflict strip on the card repeats whichever reason
 *    actually fired, OUTSIDE the select, so the information exists at least
 *    twice.
 * 2. Hard vs soft is a real distinction and is shown as one: a hard reason
 *    (day off, wrong location, a blocked chunk over the lessons) is prefixed
 *    with a marker, a soft one (rotation repeat, part-day availability) reads
 *    as a note. Neither is forbidden — the generator itself only penalises,
 *    and an admin overriding it deliberately is the whole point of the page.
 */
function TeacherPicker({ id, value, candidates, onChange, disabled, ariaLabel }) {
	const selected = candidates.find((candidate) => candidate.id === value);

	return (
		<div className='ts-picker'>
			<select
				id={id}
				className='ts-picker__select'
				value={value || ''}
				onChange={(event) => onChange(event.target.value)}
				disabled={disabled}
				aria-label={ariaLabel || 'Assigned teacher'}>
				<option value=''>Unassigned</option>
				{candidates.map((candidate) => (
					<option key={candidate.id} value={candidate.id}>
						{candidate.reason
							? `${candidate.name} — ${candidate.hard ? '✕ ' : ''}${candidate.reason}`
							: candidate.name}
					</option>
				))}
			</select>
			{selected?.reason && (
				<p
					className={`ts-picker__reason${selected.hard ? ' is-hard' : ''}`}
					role={selected.hard ? 'alert' : undefined}>
					{selected.hard ? 'Not available: ' : 'Note: '}
					{selected.reason}
				</p>
			)}
		</div>
	);
}

export default TeacherPicker;
